import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScorePewsListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller ({ component: ScorePewsListAliases.LAYOUT_SCORE_PEWS_LIST, fragment: FragmentNames.SCORE_PEWS_LIST })
export default class ScorePewsListController extends BaseController {

  @Inject(ScorePewsListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScorePewsListAliases.PANEL_GLOBAL_ACTIONS })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScorePewsListAliases.ADD_SCORE_PEWS_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_PEWS_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScorePewsListAliases.DECK_SCORE_PEWS })
  handleClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo));
    const route = accessViewer ? ApplicationRoute.SCORE_PEWS_VIEWER : ApplicationRoute.SCORE_PEWS_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
